import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'
import {IS_SERVER} from '@github-ui/ssr-utils'
import {useEffect, useState} from 'react'
import {useRelayEnvironment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {
  useIssueFormSecondaryQuery,
  useIssueFormSecondaryQuery$data,
} from './__generated__/useIssueFormSecondaryQuery.graphql'

type useIssueFormSecondaryQueryProps = {
  repoId: string
}

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
export const useIssueFormSecondaryGraphqlQuery = graphql`
  query useIssueFormSecondaryQuery($id: ID!) {
    node(id: $id) {
      ... on Repository {
        securityPolicyUrl
        contributingFileUrl
        codeOfConductFileUrl
        supportFileUrl
      }
    }
  }
`

type SecondaryQueryData = {
  securityPolicyUrl: string | null
  contributingFileUrl: string | null
  codeOfConductFileUrl: string | null
  supportFileUrl: string | null
}

export function useIssueFormSecondaryQuery({repoId}: useIssueFormSecondaryQueryProps): SecondaryQueryData | null {
  const environment = useRelayEnvironment()
  const [secondaryQueryData, setSecondaryQueryData] = useState<SecondaryQueryData | null>(null)

  useEffect(() => {
    if (!IS_SERVER) {
      clientSideRelayFetchQueryRetained<useIssueFormSecondaryQuery>({
        environment,
        query: useIssueFormSecondaryGraphqlQuery,
        variables: {
          id: repoId,
        },
      }).subscribe({
        next: (data: useIssueFormSecondaryQuery$data) => {
          setSecondaryQueryData({
            securityPolicyUrl: data.node?.securityPolicyUrl ?? null,
            contributingFileUrl: data.node?.contributingFileUrl ?? null,
            codeOfConductFileUrl: data.node?.codeOfConductFileUrl ?? null,
            supportFileUrl: data.node?.supportFileUrl ?? null,
          })
        },
      })
    }
  }, [environment, repoId])

  return secondaryQueryData
}
